module.exports = __webpack_public_path__ + "img/main-bg-mobile.b084ee01.jpg";